import { Box, Stack, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Images } from '../../assets/common';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Bidding from './Bidding';

export default function LeftBarAuction({ auctionHouse, handleBiding, handleAuction }) { 
    const { t, i18n } = useTranslation("common");

    return (
        <>
            {auctionHouse["bidData"] && auctionHouse["bidData"].length > 0 ? (
                    <Box id="sideBarAuctionMenu" sx={{ padding: "0 30px" }}>
                        <Stack spacing={1.5} sx={{ maxHeight: "200px" }}>
                            <Typography color="default" className="fs-11 mb-15 ls2-2 mt-20">
                                {t("sidebar.menu3.title")}
                            </Typography>
                            <Stack sx={{ overflow: "scroll", margin: "0 !important" }}>
                                {auctionHouse &&
                                    auctionHouse["bidData"].map((bid, index) => (
                                        <Bidding
                                            nftDetails={bid}
                                            key={index}
                                            onClick={() => handleBiding(bid)}
                                        />
                                    ))}
                            </Stack>
                        </Stack>
                    </Box>
                ) : null}

        {auctionHouse["auctionData"] &&
        auctionHouse["auctionData"].length > 0 ? (
            <Box id="sideBarAuctionData" sx={{ padding: "0 30px" }}>
                <Stack spacing={1.5} sx={{ maxHeight: "200px" }}>
                    <Typography color="default" className="fs-11 mb-15 ls2-2 mt-20">
                        {t("sidebar.menu4.title")}
                    </Typography>
                    <Stack sx={{ overflow: "scroll", margin: "0 !important" }}>
                        {auctionHouse &&
                            auctionHouse["auctionData"].map((auction, index) => (
                                <Bidding
                                    nftDetails={auction}
                                    key={index}
                                    onClick={() => handleAuction(auction)}
                                />
                            ))}
                    </Stack>
                </Stack>
            </Box>
        ) : null}
    </>
);
}